import React from "react";

import { Flex, Text } from "atoms";

export const SidebarNavItem = ({
  color,
  fontFamily,
  sidebarTitle,
  hideSidebar,
  ...props
}) => (
  <Flex
    minHeight="4rem"
    transition="all 0.3s"
    cursor="pointer"
    py=".5rem"
    {...props}
  >
    <Text
      color={color}
      fontFamily={fontFamily}
      ml="1.6rem"
      _hover={{
        fontFamily: "NeometricBold",
        color: "primary.900",
      }}
    >
      {sidebarTitle}
    </Text>
  </Flex>
);
